import React from "react";

const references = [
    { name: "KOÇ HOLDİNG", logo: "koc" },
    { name: "AKDENİZ KİMYA", logo: "akdeniz" },
    { name: "The Grand Tarabya", logo: "grandTarabya" },
    { name: "Bayraktar Holding", logo: "bayraktar" },
    { name: "ZORLU HOLDİNG", logo: "zorlu" },
    { name: "Sabancı", logo: "sabanci" },
    { name: "Özgörkey", logo: "ozgorkey" },
    { name: "Dasif", logo: "dasif" },
];

const Referanslar = () => {
    return (
        <section
            id="referanslar"
            className="relative min-h-screen w-full bg-cover bg-center bg-fixed text-white"
            style={{ backgroundImage: "url('images/references.png')" }} // arka planını buraya koy
        >
            {/* Koyu overlay */}
            <div className="absolute inset-0 bg-black/40"></div>

            <div className="relative max-w-6xl mx-auto px-4">
                {/* Başlık */}
                <div className="text-center mb-12">
                    <h2 className="text-3xl md:text-4xl font-extrabold text-white tracking-wider pt-24">
                        Referanslar
                    </h2>
                    <div className="w-24 h-[2px] bg-white/70 mx-auto mt-4" />
                </div>

                {/* Grid */}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-x-10 gap-y-12 md:gap-y-16">
                    {references.map((ref, index) => (
                        <div
                            key={index}
                            className="flex flex-col items-center text-center text-white"
                        >
                            <div className="w-28 h-28 md:w-32 md:h-32 rounded-full bg-white shadow-lg flex items-center justify-center mb-4">
                                <img
                                    src={"images/references/" + ref.logo + ".png"}
                                    alt={ref.name}
                                    className="max-w-[70%] max-h-[70%] object-contain"
                                />
                            </div>
                            <span className="text-xs md:text-sm font-semibold tracking-wide">
                                {ref.name}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Referanslar;
